import React, { useState, useEffect,useContext } from 'react';
import Routes from '../routes';
import UserInfo from '../UserInfo';
import { fetchFilterValues } from '../utils';
import LanguageContext from '../LanguageContext';
import Select from "./Common/Select"
import Input from "./Common/InputField"
import Table from './Common/Table';
import Column from './Common/Table/Column';
import { PrimaryButton } from './Common';
import { Translate } from '../Utils/Languages/Translate'
import toast from 'react-hot-toast';
import { Grid } from '@mui/material';

const LanguageDemo = () => {
    const {currentLanguage,setCurrentLanguage } = useContext(LanguageContext);
    const [filters, setFilters] = useState([]);
    const [assetCount, setAssetCount] = useState(null);
    const [assetCountError,setAssetCountError] = useState(null);
    const fetchData = async () => {
        const data = await fetchFilterValues(Routes.WorkOrder.TableFilters());
        setFilters(data);
    };

    useEffect(() => {
        fetchData()
    },[])

    const languageOptions = [
        {label : "English", value : 'en-US'},
        {label : "Spanish", value : 'es-ES'},
        {label : 'French', value : 'fr-FR'},
        {label : 'Hindi', value : 'hi-HI'},
    ];

    const changeLanguage = (lang) => {
        setCurrentLanguage(lang);
        console.log('Changed Language to : ', lang);
        UserInfo.setUserCulture(lang);
    }

    useEffect(() => {
        fetchData();
    }, []);


    const callNotification = (type) => {
        if (assetCount === undefined || assetCount === null || assetCount == 0) {
            setAssetCountError("ERROR")
            return
        }
        if (type == 'success') {
            toast.success(Translate("successAssetCreate", { assetCount: assetCount}), { duration: 6000 });
        } else {
            toast.error(Translate("failedAssetCreate", { assetCount: assetCount - 1}), { duration: 6000 });

        }
    }


    return (
        <>
            <p>
                 {/*<FormattedMessage id="locationHeader" defaultMessage="Default Load" /> */}
                {Translate('locationHeader')}
            </p>
            <Grid container mt={5} xs={12} lg={12}>
                <Grid item xs={3} lg={3} mb={6}>
                    <Select
                        value={currentLanguage}
                        label={Translate("LanguageID")}
                        variant="filled"
                        options={languageOptions}
                        onChange={e => changeLanguage(e.target.value)}
                    />
                </Grid>
                <Grid xs={8} />
                <Grid xs={1} />
                <Grid>
                    <Input
                        fullWidth
                        label="Asset Count"
                        value={assetCount}
                        onChange={e => setAssetCount(e.target.value)}
                        error={assetCountError}
                        helperText={Translate('FieldRequired')}
                  />
                </Grid>
                <Grid xs={0.4} />

                <Grid item mb={5} pt={1}>
                    <PrimaryButton
                        id="create_Button"
                        buttonText={Translate("notificationError")}
                        onClick={() => callNotification('error')}
                    />
      
                </Grid>
                <Grid item pt={1} ml={2}>
                    <PrimaryButton
                        id="create_Button"
                        buttonText={Translate("notificationSuccess")}
                        onClick={() => callNotification('success')}
                    />
                </Grid>
                <Grid item mb={5} ml={2} pt={1}>
                    <PrimaryButton
                        id="create_Button"
                        buttonText={Translate('createWorkOrder')}
                    />
                </Grid>
                <Grid xs={8} />

                <Grid item xs={5} lg={5}>
                    <p>Plain Text</p>
                    <p id="">
                        {Translate('workOrderDispatch.scheduled-date-required')}
                    </p>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <Table url={Routes.WorkOrder.WorkOrderTable()} filterOptions={filters} refresh={false} showColumnHeaderFilter={true}>
                        <Column showStatus statusProperty="status" deletedProperty="isDeleted" id='WorkOrderIDHeader' title="WORK ORDER ID" property="id" link="/WorkOrder/" linkId="id" filter="text" isWorkOrder />
                        <Column id='assetEditView.location' title="LOCATION" property="locationName" filter="dropdown" link="/Location/" linkId="locationID" />
                        <Column id='createWorkOrder.work-order-number' title="WORK ORDER NUMBER" property="workOrderNumber" filter="text" />
                        <Column id='CityHeader' title="CITY" property="city" filter="dropdown" visible={false} />
                        <Column id='workOrderRepeater.repeaterItem-scheduled-date' title="SCHEDULED DATE" property="scheduledDate" filter="date" />
                        <Column id='CreatedOnHeader' title="CREATED ON" property="createdOn" type="dateTime" visible={false} />
                        <Column id='workOrderDetailsMain.status' title="STATUS" property="status" filter="dropdown" visible={false} />
                        <Column id='workOrderDetailsMain.status-reason' title="STATUS REASON" property="statusReason" filter="dropdown" />
                        <Column id='workOrderRepeater.repeaterItem-servicer' title="SERVICER" property="servicer" filter="dropdown" />
                        <Column id='workOrdersView.work-type' title="WORK TYPE" property="type" filter="dropdown" />
                        <Column id='assetDetailsMainTab.assetservicerequirementlist-due-date' title="DUE DATE" property="dueDate" filter="date" visible={false} />
                        <Column id='RegionHeader' title="REGION/DIVISION" property="regionDivision" filter="dropdown" visible={false} />
                    </Table>
                </Grid>
 
            </Grid>
        </>
    );

};

export default LanguageDemo;
